import React from "react";
import { BigNumber } from "ethers";
import { parseUnits } from "@ethersproject/units";

export const useStringAsBn = (value: string, decimals: number): BigNumber => {
  return React.useMemo(() => {
    try {
      return parseUnits(value || "0", decimals);
    } catch (e) {
      return BigNumber.from(0);
    }
  }, [value, decimals]);
};
